/**
 * Draws each card's icon once the card itself is revealed — same shape as
 * the framework block's icons. Skipped under reduced motion; icons are fully
 * painted at rest.
 */
import { reducedMotion } from '../../src/js/utils/motion';

const setup = (card: HTMLElement): void => {
  const shapes = card.querySelectorAll<SVGGeometryElement>('[data-format-icon] path, [data-format-icon] circle');

  if (!shapes.length) {
    return;
  }

  const draws = Array.from(shapes).map((shape) => {
    const length = shape.getTotalLength();

    shape.style.strokeDasharray = `${length}`;
    shape.style.strokeDashoffset = `${length}`;

    return () =>
      shape.animate(
        { strokeDashoffset: [`${length}`, '0'] },
        { duration: 550, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
      );
  });

  const run = (): void => draws.forEach((draw) => draw());

  if (card.classList.contains('is-revealed')) {
    run();
    return;
  }

  card.addEventListener('goodface:revealed', run, { once: true });
};

const init = (): void => {
  if (reducedMotion()) {
    return;
  }

  document.querySelectorAll<HTMLElement>('.format-comparison__card').forEach(setup);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

export {};
